module.exports = __webpack_public_path__ + "img/Activites.1c3c8662.svg";